import Dashboards from './Dashboards'

export default Dashboards
